import { Tab } from "@headlessui/react";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";

import { LibrarySetting } from "./library-setting";
import { VideoURLSetting } from "./url-setting";
import { VideoShareUrlSetting } from "./video-share-url-setting";

/**
 * Full v2 single-video settings: tabs plus recording metadata / share URL below.
 * Reorder tabs or fields here; legacy has no v2 UI.
 */
export function VideoSettingsV2() {
  const { t } = useTranslation();

  return (
    <Fragment>
      <Tab.Group as="div" className="relative">
        <Tab.List className="flex h-12 w-full items-center justify-center text-sm">
          <Tab className="h-full flex-1 cursor-pointer border-solid font-medium focus:outline-none ui-selected:border-b-2 ui-selected:border-primary ui-selected:text-gray-800 ui-not-selected:border-b ui-not-selected:border-gray-300 ui-not-selected:text-gray-650">
            {t("preference-panel.library")}
          </Tab>
          <Tab className="h-full flex-1 cursor-pointer border-solid font-medium focus:outline-none ui-selected:border-b-2 ui-selected:border-primary ui-selected:text-gray-800 ui-not-selected:border-b ui-not-selected:border-gray-300 ui-not-selected:text-gray-650">
            {t("preference-panel.url")}
          </Tab>
        </Tab.List>
        <Tab.Panels as={Fragment}>
          <Tab.Panel as={Fragment}>
            <LibrarySetting />
          </Tab.Panel>
          <Tab.Panel>
            <VideoURLSetting />
          </Tab.Panel>
        </Tab.Panels>
      </Tab.Group>
      <VideoShareUrlSetting />
    </Fragment>
  );
}
